import React from 'react';
import ReactDOM from 'react-dom';
import TextField from 'material-ui/TextField';


import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';

import Grading from './grading.js';

class SIUnitsPractice extends React.Component{


  //handles user inputs of their attempt at recalling the amino acids


  handleUserInputJoule(e){
   this.setState({
     joule: e.target.value,
   });

 }

 handleUserInputWatt(e){
  this.setState({
    watt: e.target.value,
  });

}

  handleUserInputPascal(e){
   this.setState({
     pascal: e.target.value,
   });

 }

   handleUserInputAmpere(e){
    this.setState({
      ampere: e.target.value,
    });

  }

 handleUserInputVolt(e){
  this.setState({
    volt: e.target.value,
  });

}



handleUserInputOhm(e){
 this.setState({
   ohm: e.target.value,
 });

}


handleUserInputFarad(e){
this.setState({
  farad: e.target.value,
});

}

handleUserInputNewton(e){
this.setState({
  newton: e.target.value,
});

}

handleUserInputHertz(e){
this.setState({
  hertz: e.target.value,
});

}

//initializing the textFields

 constructor(props){
   super(props);
   this.state = {joule: '',
   watt: '',
   pascal: '',
   ampere: '',
   volt: '',
   ohm: '',
   farad: '',
   newton: '',
   hertz: ''
     };

    //following the requirement of binding handleInputs
   this.handleUserInputJoule = this.handleUserInputJoule.bind(this);
   this.handleUserInputWatt = this.handleUserInputWatt.bind(this);
   this.handleUserInputPascal = this.handleUserInputPascal.bind(this);
   this.handleUserInputAmpere = this.handleUserInputAmpere.bind(this);
   this.handleUserInputVolt = this.handleUserInputVolt.bind(this);
   this.handleUserInputOhm = this.handleUserInputOhm.bind(this);
   this.handleUserInputFarad = this.handleUserInputFarad.bind(this);
   this.handleUserInputNewton = this.handleUserInputNewton.bind(this);
   this.handleUserInputHertz = this.handleUserInputHertz.bind(this);

   //the textFields
   var shuffle = require('shuffle-array');
   this.state = {};
   this.SIUnitsArray = shuffle([
     //All the text fields
         <div> <div style = {{color: '#00B8D4'}}> J = </div> <TextField  onChange = {this.handleUserInputJoule} value = {this.state.joule}/> </div>,
         <div> <div style = {{color: '#00B8D4'}}> W = </div> <TextField  onChange = {this.handleUserInputWatt} value = {this.state.watt}/> </div>,
         <div> <div style = {{color: '#00B8D4'}}> Pa = </div> <TextField  onChange = {this.handleUserInputPascal} value = {this.state.pascal}/> </div>,
         <div> <div style = {{color: '#00B8D4'}}> A = </div> <TextField  onChange = {this.handleUserInputAmpere} value = {this.state.ampere}/> </div>,
         <div> <div style = {{color: '#00B8D4'}}> V = </div> <TextField  onChange = {this.handleUserInputVolt} value = {this.state.volt}/> </div>,
         <div> <div style = {{color: '#00B8D4'}}> Ω = </div> <TextField  onChange = {this.handleUserInputOhm} value = {this.state.ohm}/> </div>,
         <div> <div style = {{color: '#00B8D4'}}> F = </div> <TextField  onChange = {this.handleUserInputFarad} value = {this.state.farad}/> </div>,
         <div> <div style = {{color: '#00B8D4'}}> Hz = </div> <TextField  onChange = {this.handleUserInputHertz} value = {this.state.hertz}/> </div>,
         <div> <div style = {{color: '#00B8D4'}}> N = </div> <TextField  onChange = {this.handleUserInputNewton} value = {this.state.newton}/> </div>

   ]);



 }



  render(){
    let textFields = this.SIUnitsArray.map(SIUnits => <ul> {SIUnits} </ul> );

    return(
      <MuiThemeProvider>
      <div style = {{paddingTop: 20}}>

       {textFields}

       <Grading joule = {this.state.joule} watt = {this.state.watt}
          pascal = {this.state.pascal} ampere = {this.state.ampere}
          volt = {this.state.volt} ohm = {this.state.ohm}
          ohm1 = {this.state.ohm1} farad = {this.state.farad}
          newton = {this.state.newton} hertz = {this.state.hertz}
          />

      </div>

      </MuiThemeProvider>
    );

  }

}

export default SIUnitsPractice;



// WEBPACK FOOTER //
// ./src/SIUnits/SIUnitsPractice.js